const shared = {
  caliberTitle: '口徑版本與數據截止日期',
  caliber: '口徑',
  through: '截至',
  batch: '批次',
  denominator: '分母',
  loading: '正在讀取採樣數據…',
  readFailure: '這塊數據未能讀取',
  readFailureClarification: '這不代表企業沒有出現在 AI 結果中——只是本次讀取失敗，兩者不能混為一談。',
  permissionTitle: '你暫時無法存取這個專案',
  permissionBody: '請切換到已獲授權的專案，或請專案負責人為你開通權限。',
  retry: '重新讀取',
  closeEvidence: '關閉證據',
  provenance: {
    real: '真實數據',
    construct: '構造數據',
    placeholder: '占位判據',
  },
  session: {
    secureSession: '安全工作階段',
    contextTitle: '進入領航者。',
    contextBody: '安全地繼續到你的企業空間。',
    pathLabel: '帳戶建立進度',
    pathOneTitle: '驗證信箱',
    pathOneBody: '一次性登入連結只會寄給企業空間中的有效成員。',
    pathTwoTitle: '選擇或建立企業',
    pathTwoBody: '目前工作階段只能讀取該企業分配給你的專案。',
    pathThreeTitle: '開始工作',
    pathThreeBody: '診斷、行動與成果會在不暴露內部憑證的前提下恢復。',
    memberEntry: '企業成員登入',
    requestTitle: '用信箱繼續。',
    requestLead: '已有成員直接登入；新使用者驗證後建立企業空間。',
    afterLogin: '登入後',
    destination: {
      diagnosis: '返回診斷',
      results: '返回成果',
      action: '返回行動',
      research: '返回企業研究',
    },
    emailLabel: '工作信箱',
    invalidEmail: '請輸入有效的工作信箱。',
    sendLink: '繼續',
    sending: '正在傳送…',
    privacyTitle: '僅限企業成員。',
    privacyBody: '信箱僅用於登入與必要的帳戶通知。',
    checkEyebrow: '申請已受理',
    checkTitle: '請檢查你的信箱',
    checkLead: '安全連結已經寄出。請在此裝置開啟郵件並繼續。',
    linkLifetime: '連結 15 分鐘內有效',
    resendShort: '重新傳送',
    changeEmail: '更換信箱',
    verifyingEyebrow: '正在核驗成員身分',
    verifyingTitle: '正在開啟企業空間',
    verifyingLead: '系統正在將一次性連結兌換為受保護的瀏覽器工作階段。',
    expiredEyebrow: '連結不可用',
    expiredTitle: '這條登入連結已過期或已經使用',
    expiredLead: '請用同一個已獲授權的工作信箱申請新連結，專案資料沒有發生變化。',
    requestNewLink: '申請新連結',
    problemEyebrow: '連線中斷',
    problemTitle: '暫時無法申請登入連結',
    problemLead: '請檢查網路後重試，企業空間中的資料沒有發生變化。',
    chooseSpaceEyebrow: '企業空間',
    chooseSpaceTitle: '選擇這次要進入的企業空間',
    chooseSpaceLead: '{email} 已獲多個企業空間授權。選擇後只會讀取該空間的資料，進入後仍可隨時切換。',
    openingSpace: '正在進入…',
    chooseSpaceFailed: '暫時無法進入這個企業空間，請重試。',
    createEyebrow: '信箱已驗證',
    createContextTitle: '一個身分，進入你所屬的每一家企業。',
    createContextBody: '企業空間承載專案、成員、記憶與權益。',
    createTitle: '建立企業空間。',
    createLead: '填寫基本資料。個人創業者可使用品牌或工作室名稱。',
    verifiedIdentity: '已驗證',
    orgName: '企業 / 品牌 / 團隊名稱',
    region: '主要營運地區',
    website: '官網或首頁',
    optional: '選填',
    terms: '我有權代表該企業，並同意服務條款與隱私政策。',
    createButton: '建立企業空間',
    creatingWorkspace: '正在建立…',
    regionCN: '中國大陸',
    regionGlobal: '其他國家或地區',
    regionHK: '中國香港',
    regionTW: '中國台灣',
    regionJP: '日本',
    regionKR: '韓國',
    createBoundary: '註冊不會自動開通付費功能。',
    companyNameInvalid: '請輸入企業、品牌或團隊名稱。',
    termsRequired: '請先同意服務條款與隱私政策。',
    registrationFailed: '暫時無法建立企業空間，請重試。',
    footerSecurity: '一次性連結 · 受保護 Cookie · 租戶隔離',
    footerHelp: '需要協助 · hello@monolithos.ai',
  },
} as const

export default shared
